import './Donazioni.css';

function Donazioni() {
    return (
        <div className='donazioni-container'>
            <h1 className='donazioni-title'>Donazioni</h1>

            <p>
                L'Associazione Settemotivi - ODV produce programmi radio visivi che sono trasmessi 24 ore al giorno,
                tutti i giorni della settimana, dal 1° febbraio 2021 nella media partner Radio Cosmo.
            </p>
            <p>
                L'Associazione si regge, in parte, grazie ai progetti finanziati dalla Regione FVG, dal 5xmille
                e dalle erogazioni liberali oltre all'autofinanziamento da parte dei soci.
            </p>

            <p>Potete sostenerci e vi ringraziamo fin d'ora per quello che potrete fare tramite:</p>

            <ul className='donazioni-list'>
                <li>
                    il 5xmille indicando nella apposita casella – enti del terzo settore ed inserendo il
                    C.F. 911 000 00 933;
                </li>
                <li>
                    l'erogazione liberale, che vi consente di portare in detrazione il 35% della somma
                    erogata sul conto corrente intestato a: Associazione Settemotivi – ODV<br />
                    <span className='donazioni-iban-block'>
                        IBAN IT73 O 0835 664960 0000000 67146 - BCC Pordenone e Monsile<br />
                        Agenzia di Prata di Pordenone
                    </span>
                </li>
            </ul>
        </div>
    );
}

export default Donazioni;
